export function isTimeInRange(startTime: string, endTime: string): boolean {
  const now = new Date();
  const start = startTime ? new Date(Number(startTime) || startTime) : null;
  const end = endTime ? new Date(Number(endTime) || endTime) : null;

  return start
    ? end
      ? now >= start && now < end // start and end
      : now >= start // start only
    : end
    ? now < end // end only
    : true; // no start and no end
}
